import { Prismic, Embed } from '@landsbankinn/prismic';
import { Segment } from '@landsbankinn/ui';
import React from 'react';
import { MediaItem } from '../components/media-item/MediaItem';

interface IProps {
  video: Prismic.Embed;
  title?: Prismic.RichText;
  title1?: Prismic.RichText;
  copy: Prismic.RichText;
}

export const VideoContainer = ({ video, title, title1, copy }: IProps) => {
  if (!video) {
    return null;
  }

  return (
    <Segment>
      <MediaItem
        title={Prismic.text(title) || Prismic.text(title1)}
        copy={Prismic.text(copy)}
      >
        <Embed
          html={(video as any)[0]?.oembed?.html}
          noSpace={true}
          type="inline"
        />
      </MediaItem>
    </Segment>
  );
};
